// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__219zP","label":"SetPasswdForm_label__1jJOz"};